import { EhrSessionDataSummaryPartsFragment } from "@api/graphql/types-and-hooks";

// Dates arrive formatted from FDM.
export const describeSessionSummary = (summary: EhrSessionDataSummaryPartsFragment) =>
  `${summary.dataPointCount} data points · ${summary.sessionCount} sessions · ${summary.firstDate ?? "?"} → ${summary.lastDate ?? "?"}`;
